import React from 'react';
import './BusinessModelsSection.css';

const models = [
  {
    title: 'Freelance Services',
    summary: 'Sell a focused skill to one niche and land first clients through daily outreach.',
    bestFor: 'Fastest path to first revenue',
  },
  {
    title: 'Social Media Management',
    summary: 'Manage content calendars, reels, and growth reporting for local businesses.',
    bestFor: 'Creative execution and recurring retainers',
  },
  {
    title: 'Affiliate Content Business',
    summary: 'Publish comparison and review content, then earn commissions from buyer intent traffic.',
    bestFor: 'Long-term compounding income',
  },
  {
    title: 'Digital Products Business',
    summary: 'Create templates, guides, and kits once, then sell repeatedly with low overhead.',
    bestFor: 'Scalable product-led income',
  },
  {
    title: 'Coaching and Consulting',
    summary: 'Package expertise into outcomes and sell transformation-focused offers.',
    bestFor: 'High-value service model',
  },
  {
    title: 'No-Code Automation Services',
    summary: 'Build lead capture and follow-up automations for businesses using simple tools.',
    bestFor: 'Systems-focused operators',
  },
];

const BusinessModelsSection = ({ sectionNumber = '02' }) => (
  <section className="models-section" id="models" title={sectionNumber}>
    <div className="models-container">
      <div className="models-header">
        <h2>Curated Ideas For You</h2>
        <p>Selected from the Top Online Business Ideas India Edition playbook.</p>
      </div>

      <div className="models-grid">
        {models.map((model) => (
          <article key={model.title} className="model-card">
            <h3>{model.title}</h3>
            <p>{model.summary}</p>
            <span>{model.bestFor}</span>
          </article>
        ))}
        <div style={{ textAlign: 'center', marginTop: '32px' }}>
          <a
            href="/buy"
            className="model-purchase-link"
            style={{
              display: 'inline-block',
              padding: '12px 32px',
              background: '#0f5fb4',
              color: '#fff',
              borderRadius: '10px',
              textDecoration: 'none',
              fontWeight: 700,
              fontSize: '1.1rem',
              boxShadow: '0 2px 8px rgba(18,39,68,0.08)',
              transition: 'background 0.2s',
            }}
            onClick={e => {
              e.preventDefault();
              window.history.pushState({}, '', '/buy');
              window.dispatchEvent(new PopStateEvent('popstate'));
            }}
          >
            Buy This E-Book
          </a>
        </div>
      </div>
    </div>
  </section>
);

export default BusinessModelsSection;
